/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const AngryIcon = props => {
	const { color = '' } = props
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			x={0}
			y={0}
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path
				className='st0'
				d='M25 0C11.2 0 0 11.2 0 25s11.2 25 25 25 25-11.2 25-25S38.8 0 25 0zm0 48.2C12.2 48.3 1.8 37.8 1.8 25 1.8 12.2 12.2 1.8 25 1.8c12.8 0 23.2 10.4 23.3 23.2 0 12.8-10.4 23.2-23.3 23.2z'
			/>
			<path
				className='st0'
				d='M16.1 16.3c-.2-.3-.6-.4-.9-.5-.4 0-.7.1-1 .3-.3.2-.4.6-.5.9 0 .4.1.7.3 1l2.6 3.1-3.9.6c-.7.1-1.1.7-1.1 1.3 0 .7.6 1.3 1.3 1.3h.2l8.6-1.4-5.6-6.6zM36.5 21.8l-3.9-.8 2.6-3c.3-.5.3-1.2-.1-1.6-.2-.3-.6-.4-.9-.5-.4 0-.7.1-1 .4l-5.6 6.4 8.4 1.7h.3V24v.4c.6 0 1.1-.4 1.2-1 .1-.3.1-.7-.1-1-.2-.2-.5-.5-.9-.6zm-.3 2.2v.3-.3zM24.9 27.9c-4.4 0-8.3 2.9-9.6 7.1 0 .1-.1.2-.1.4 0 .7.6 1.3 1.3 1.3.6 0 1.1-.4 1.3-1 1-3.1 3.8-5.2 7-5.2h.1c3.2 0 6 2.1 6.9 5.2.1.3.3.6.7.8.3.2.7.2 1 .1.7-.2 1.1-1 .9-1.7-1.3-4.1-5.1-6.9-9.5-7z'
			/>
		</svg>
	)
}

export default AngryIcon
